import moment from 'moment-timezone';

import { latestReceipt } from '../../../utils/readingReceipt';

export function getHeartRateReceipt(group, source, interval) {
  const intervalEnd = moment.unix(source.timestamp).startOf(interval).add(1, interval).toISOString();
  return {
    backend_timestamp: latestReceipt(group.backend_timestamp, source.backend_timestamp),
    receipt_reference: latestReceipt(group.receipt_reference, intervalEnd),
  };
}
